/** チャンネルイベント条件のユースケースタイプ */
export type ChannelEventConditionUsecaseTypeType = 'STAY_ALERT';
export const ChannelEventConditionUsecaseTypeTypes: ChannelEventConditionUsecaseTypeType[] = ['STAY_ALERT'];
export function convertChannelEventConditionUsecaseTypeType(s?: string, undef?: boolean) {
  for (const v of ChannelEventConditionUsecaseTypeTypes) if (v === s) return s;
  return undef ? undefined : ChannelEventConditionUsecaseTypeTypes[0];
}
